import dayjs from "dayjs";
import { PDFDocument, rgb } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { EMPLOYMENT_FIELD_TYPES } from "@/assets/variables";

/**
 * @param {import("..").EmploymentContract} contract
 * @returns
 */
export async function downEmploymentContract(contract) {
    ////////////////////////////////////////////////////////////////////////////
    // 문서 로드
    ////////////////////////////////////////////////////////////////////////////
    let { url } = contract?.form?.file || {};
    if (!url) throw new Error("잘못된 요청입니다");

    let arrayBuffer = await fetch(url).then((response) => response.arrayBuffer());
    let pdfDoc = await PDFDocument.load(arrayBuffer);

    // fontkit 등록 - 커스텀 폰트를 사용하기 전에 필요
    pdfDoc.registerFontkit(fontkit);

    ////////////////////////////////////////////////////////////////////////////
    // 필드 처리
    ////////////////////////////////////////////////////////////////////////////
    let pages = pdfDoc.getPages();
    let fields = [...(contract?.fields_document || []), ...(contract?.fields_employee || [])].filter(({ type }) => type != EMPLOYMENT_FIELD_TYPES.FILE.value);

    // 폰트 로드
    let font = await (async () => {
        let arrayBuffer = await fetch("/fonts/PretendardGOV-Regular.ttf").then((res) => res.arrayBuffer());
        return await pdfDoc.embedFont(arrayBuffer);
    })();

    for (let field of fields) {
        let page = pages[field.page];

        let pageWidth = page.getWidth();
        let pageHeight = page.getHeight();

        let width = field.size.w * pageWidth;
        let height = field.size.h * pageHeight;

        let x = field.axis.x * pageWidth;
        let y = pageHeight - (field.axis.y * pageHeight + height);

        let size = (pageWidth / 784) * 16;

        switch (field.type) {
            case EMPLOYMENT_FIELD_TYPES.CBOX.value: {
                let font = await (async () => {
                    let arrayBuffer = await fetch("/fonts/materialdesignicons-webfont.ttf").then((res) => res.arrayBuffer());
                    return await pdfDoc.embedFont(arrayBuffer);
                })();

                let unicode = String.fromCodePoint(0xf0132);
                let size = (pageWidth / 784) * 22;
                let fieldWidth = font.widthOfTextAtSize ? font.widthOfTextAtSize(unicode, size) : size;

                let iconX = x + (width - fieldWidth) / 2;
                let iconY = y + (height - size) / 2;

                page.drawText(unicode, {
                    x: iconX,
                    y: iconY,
                    size,
                    font,
                    color: rgb(49 / 255, 15 / 255, 161 / 255),
                });

                break;
            }
            case EMPLOYMENT_FIELD_TYPES.DATE.value:
            case EMPLOYMENT_FIELD_TYPES.TEXT.value: {
                let text = field.data || "";
                let letterSpacing = -0.32;
                let pdfLetterSpacing = letterSpacing * (72 / 96);

                let totalWidth = 0;
                if (font.widthOfTextAtSize) {
                    for (let i = 0; i < text.length; i++) {
                        totalWidth += font.widthOfTextAtSize(text[i], size);
                        if (i < text.length - 1) {
                            totalWidth += pdfLetterSpacing;
                        }
                    }
                } else {
                    totalWidth = text.length * size * 0.6 + (text.length - 1) * pdfLetterSpacing;
                }

                let startX = x + (width - totalWidth) / 2;
                let centeredY = y + height / 2 - size / 3;

                for (let i = 0; i < text.length; i++) {
                    let char = text[i];

                    let charWidth = font.widthOfTextAtSize ? font.widthOfTextAtSize(char, size) : size * 0.6;

                    page.drawText(char, {
                        x: startX,
                        y: centeredY,
                        size,
                        font,
                        color: rgb(0, 0, 0),
                    });

                    startX += charWidth + pdfLetterSpacing;
                }
                break;
            }
            case EMPLOYMENT_FIELD_TYPES.SIGN.value: {
                let imgUrl = field.img?.url;
                if (!imgUrl) break;

                let imgArrayBuffer = await fetch(imgUrl).then((response) => response.arrayBuffer());
                let img = await (async () => {
                    let ext = imgUrl.toLowerCase().split(".").pop();
                    switch (ext) {
                        case "png": {
                            return await pdfDoc.embedPng(imgArrayBuffer);
                        }
                        case "jpg":
                        case "jpeg": {
                            return await pdfDoc.embedJpg(imgArrayBuffer);
                        }
                        default:
                            return null;
                    }
                })();

                if (!img) break;

                page.drawImage(img, {
                    x,
                    y,
                    width,
                    height,
                });
                break;
            }
        }
    }

    ////////////////////////////////////////////////////////////////////////////
    // 문서 변환
    ////////////////////////////////////////////////////////////////////////////

    let binary = await pdfDoc.save();
    let blob = new Blob([binary], { type: "application/pdf" });

    let fileName = (() => {
        let text = ["리본바이옴_판매_계약서", contract?.user?.name];
        text = text.filter((item) => !!item);
        text = text.join("-");

        return `${text}.pdf`;
    })();
    /** @type {FilePropertyBag} */
    let fileConf = {
        type: "application/pdf",
        lastModified: dayjs(contract.signedAt).toDate().getTime(),
    };
    let file = new File([blob], fileName, fileConf);

    return file;
}
